import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setDocumentLanguage } from '../../utils/documentLanguage.utils';

export default function DocumentLanguage() {
	const currentLanguage = useSelector(
		(state) => state.translation.currentLanguage || 'en'
	);

	useEffect(() => {
		setDocumentLanguage(currentLanguage);
	}, [currentLanguage]);

	return null;
}
